import React from 'react';
import { Box, ToggleButton } from '@mui/material';

// sign In buttons style
export const SignInButtonsStyle = {
    background: '#000',
    color: '#fff',
    fontSize: 16,
    lineHeight: 1.75,
    maxWidth: 300,
    width: '100%',
    minHeight: 50,
    borderRadius: '5px',
    margin: 0,
    transition:'background 250ms cubic-bezier(0.4, 0, 0.2, 1)',
};

// ToggleButton
export const checkIcon = (
    <svg width="30" height="30" className="check-icon" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
        <circle cx="15" cy="15" r="15" fill="#8140B7" />
        <path d="M8 15L12.5 19.5L21 11" stroke="white" strokeWidth="2" strokeLinecap="round" />
    </svg>
);

export const ToggleButtonWithIcon = ({ value, label, isActive, onClick }) => (
    <ToggleButton value={value} aria-label={label} onClick={onClick} sx={{
        borderRadius: '5px !important',
        border: isActive ? '3px solid #8140B7' : '3px solid #000',
        backgroundColor: '#000',
        fontSize: 20,
        lineHeight: 1.4,
        color: isActive ? '#fff' : '#828a99',
        textTransform: 'capitalize',
        minWidth: 300,
        minHeight: 80,
        '&:hover': {
            background: isActive ? '#5E2D89' : '#000',
            border: '3px solid #8140B7',
        },
        '&.Mui-selected,&.Mui-selected:hover,&.MuiToggleButtonGroup-lastButton': {
            background: '#000',
            border: isActive ? '3px solid #8140B7' : '3px solid #000',
            marginTop: 0,
        },
        '& .check-icon': {
            position: 'absolute',
            left: 20,
            top: '50%',
            transform: 'translateY(-50%)'
        },
    }}>
        {isActive && checkIcon}
        {label}
    </ToggleButton>
);

// fiolet button style
export const SimpleButtonStyle = {
    background: '#8140B7',
    color: '#fff',
    fontSize: 16,
    minWidth: 300,
    minHeight: 50,
    fontWeight: 500,
    textTransform: 'uppercase',
    '&.Mui-disabled': {
        background: '#8140B7',
        color: '#fff',
        opacity: 0.25
    },
    '&:hover': {
        backgroundColor: '#42a5f5',
        color: '#fff',
    },
};

// afterFormText
export const AfterFormText = {
    lineHeight: 1.37,
    fontSize: 16,
    color: '#fff',
    textAlign: 'center'
};

// resetStyleButton
export const ResetStyleButton = {
    '&.MuiButton-root': {
        color: 'inherit',
        lineHeight: 'inherit',
        fontSize: 'inherit',
        fontWeight: 700,
        m: '0 5px',
        minWidth: 'auto',
        minHeight: 'auto',
        borderRadius: 0,
        textTransform: 'none',
        boxShadow: 'none',
        backgroundColor: 'transparent',
        border: 'none',
        outline: 'none',
        '&:not(.is-button)': {
            padding: 0,
        },
        '&:not(.is-button):hover': {
            backgroundColor: 'transparent',
            color: '#42a5f5'
        },
        '&.width-auto': {
            width: 'fit-content',
        },
        '&.x-auto': {
            m: '0 auto',
        },
        // '&.is-button:hover': {
        //     m: '0 auto',
        // },
    },
};

// icons for react-social-login-buttons
export const CustomGoogleIcon = () => {
    return (
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none"
            xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_508_264)">
                <path d="M1.61738 8.29537C2.36196 6.71553 3.40178 5.34978 4.66047 4.14973C7.0974 1.82462 9.99799 0.440467 13.3431 0.0934062C17.6524 -0.353887 21.4926 0.797075 24.7778 3.67789C24.9966 3.86949 24.9857 3.96085 24.7853 4.15791C23.4911 5.43229 22.2106 6.72098 20.928 8.00763C20.8073 8.129 20.7317 8.21423 20.5517 8.05059C17.3661 5.15886 12.1663 5.25228 8.88044 8.49652C7.82698 9.53702 7.08036 10.7637 6.57783 12.1478C4.92435 10.8639 3.27018 9.57929 1.6167 8.29537H1.61738Z" fill="#E94335" />
                <path d="M24.8911 26.3617C23.4572 27.7206 21.7832 28.6833 19.8993 29.2425C15.0466 30.6818 10.4748 30.1125 6.28345 27.1812C4.30541 25.7978 2.7842 23.9963 1.67211 21.8512C1.64619 21.8014 1.62983 21.7462 1.60938 21.6937C3.26559 20.4118 4.92248 19.13 6.57869 17.8481C7.13849 19.4041 8.00785 20.7507 9.25563 21.8478C12.1542 24.3966 16.5637 24.7607 19.8427 22.7172C19.9095 22.6756 19.9804 22.6388 20.0493 22.5999C20.6855 23.0881 21.3237 23.5722 21.9564 24.0645C22.9363 24.8275 23.9127 25.5953 24.8904 26.361L24.8911 26.3617Z" fill="#34A853" />
                <path d="M24.8911 26.3617C23.9133 25.596 22.9376 24.8282 21.9571 24.0652C21.3244 23.5729 20.6855 23.0888 20.05 22.6006C21.3919 21.6603 22.3683 20.4453 22.8613 18.8661C23.0276 18.3334 22.8342 18.067 22.281 18.067C19.9648 18.067 17.6485 18.0636 15.3323 18.0724C15.0793 18.0731 14.9832 18.0261 14.9859 17.7438C15.0002 16.018 14.9975 14.2923 14.9879 12.5665C14.9866 12.332 15.0432 12.261 15.2866 12.2617C19.7943 12.2692 24.302 12.2685 28.8097 12.2631C29.0238 12.2631 29.1329 12.3013 29.1684 12.542C29.6163 15.5735 29.4029 18.5388 28.2772 21.408C27.5292 23.3152 26.426 24.9884 24.8918 26.3624L24.8911 26.3617Z" fill="#4285F3" />
                <path d="M6.57938 17.8481C4.92316 19.1299 3.26627 20.4118 1.61006 21.6937C0.713427 19.9625 0.208177 18.1222 0.0506694 16.1796C-0.162749 13.5456 0.306363 11.0398 1.42391 8.65059C1.48119 8.52854 1.55278 8.41399 1.61756 8.29535C3.27104 9.57927 4.92453 10.8639 6.57869 12.1478C6.27186 13.1828 6.08503 14.2329 6.12526 15.3204C6.15663 16.1871 6.35232 17.0196 6.58006 17.8481H6.57938Z" fill="#FABB06" />
            </g>
            <defs>
                <clipPath id="clip0_508_264">
                    <rect width="29.3857" height="30" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};
export const CustomFacebookIcon = () => {
    return (
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M0 15.0465C0 22.797 5.84325 29.1772 13.353 30V19.6957H9.864V15.6427H13.353V12.6548C13.353 9.18675 15.4635 7.299 18.5475 7.299C20.025 7.299 21.2948 7.40925 21.6653 7.45875V11.0828L19.5263 11.0835C17.8493 11.0835 17.5238 11.883 17.5238 13.0553V15.6427H21.5243L21.003 19.6957H17.5238V29.8762C24.606 28.6717 30 22.4925 30 15.0465C30 6.7365 23.2838 0 15 0C6.7155 0 0 6.7365 0 15.0465Z" fill="#0866FF" />
        </svg>
    );
};
export const CustomTwitterIcon = () => {
    return (
        <svg width="30" height="30" viewBox="0 0 30 30" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M0 15C0 6.7155 6.7155 0 14.9993 0C23.2845 0 30 6.7155 30 15C30 23.2845 23.2845 30 14.9993 30C6.7155 30 0 23.2845 0 15ZM13.288 15.437L6.79095 6.75H11.7984L16.0577 12.4451L21.3292 6.75H22.8007L16.7151 13.3244L23.5779 22.5H18.5705L13.9457 16.3161L8.22156 22.5H6.75L13.288 15.437ZM11.2553 7.83383H8.95494L19.1132 21.4162H21.4136L11.2553 7.83383Z" fill="white" />
        </svg>
    );
};